module.exports = __webpack_public_path__ + "img/no-image.65cb82c5.svg";